import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import FormPersonalDataClient from './FormPersonalDataClient';
import { isMobile } from 'react-device-detect';
import Snackbar from '../../../components/Snackbar';
import { personalDataClient, personalDataClientSocial } from '../../../utils/validations';
import { updatePersonalDataClient, updatePersonalDataClientSocial } from '../../../store/actions/UserAction';

const UpdatePersonalDataClient = props => {
    const { name, lastName } = props.profile;  
    const [ personalData, setPersonalData ] = useState({
      name: name ? name : '',
      lastName: lastName ? lastName : '',
    })
    const [feedbackMessage, setFeedbackMessage] = useState({
      open: false,
      message: '',
      variant: 'info'
    });
  
    const handleCloseFeedbackMessage = () => {
      setFeedbackMessage({
        open: false,
        message: '',
        variant: 'info'
      });
    };

    const handlePersonalData = 
      async (values, { setSubmitting, setFieldError }) => {
        setSubmitting(false);      
          try {
            const { uid } = props.profile;
            await props.updatePersonalDataClient(uid, values)
            setFeedbackMessage({
              open: true,
              message: 'Datos personales actualizados con éxito',
              variant: 'success'
            });
          } catch (error) {
            setFeedbackMessage({
              open: true,
              message: 'Ocurrio un error, no se lograron actualizar tus datos personales',
              variant: 'error'
            });
            setFieldError('phoneNumber', 'Vuelve a intentar más tarde');
          } 
    };

    const handlePersonalDataSocial = 
      async (values, { setSubmitting, setFieldError }) => {
        setSubmitting(false);
          try {
            const { uid } = props.profile.user;
            await props.updatePersonalDataClientSocial(
              uid === undefined ? props.profile.user.uid : uid,
              values
            )
            setFeedbackMessage({
              open: true,
              message: 'Datos personales actualizados con éxito',
              variant: 'success'
            });
          } catch (error) {
            console.log(error);
            setFeedbackMessage({
              open: true,
              message: 'Ocurrio un error, no se lograron actualizar tus datos personales',
              variant: 'error'
            });
            setFieldError('phoneNumber', 'Vuelve a intentar más tarde');
          }
    };
  
    useEffect(() => {
      props.profile && 
      setPersonalData({
        name,
        lastName
      })
    }, [lastName, name, props.profile])

    return (
      <>
        
        <Formik
          initialValues={{ ...personalData }}
          validationSchema={props.profile && props.profile.registeredSocial ? 
            personalDataClientSocial : personalDataClient
          }
          onSubmit={props.profile && props.profile.registeredSocial ? 
            handlePersonalDataSocial :
            !props.profile.registeredSocial && props.profile.additionalUserInfo ?
            handlePersonalDataSocial :
            handlePersonalData
          }
          render={props => (
            <FormPersonalDataClient
              {...props}
            />
          )}
        />
        
  
        <Snackbar
          open={feedbackMessage.open}
          message={feedbackMessage.message}
          variant={feedbackMessage.variant}
          handleClose={handleCloseFeedbackMessage}
          vertical="top"
          horizontal="right"
          snackbarTop={isMobile ? '8px' : '80px'}
        />
      </>
    );
};

const mapDispatchToProps = dispatch => ({
  updatePersonalDataClient: 
    (uid, values) => dispatch(updatePersonalDataClient(uid, values)),
  updatePersonalDataClientSocial:
    (uid, values) => dispatch(updatePersonalDataClientSocial(uid, values)),
})

const mapStateToProps = state => ({
    profile: state.authClient
});
  
export default connect(mapStateToProps, mapDispatchToProps)(UpdatePersonalDataClient);